<template>
  <main role="main" class="main">
    <div class="msum-Kv">
      <div class="msum-Kv__inner">
        <h1 class="msum-Kv__title">
          <img :src="base_url +'img/title_main.png'" alt="History" />
        </h1>
        <p class="msum-Kv__title2">森永の歴史年表</p>
      </div>
      <p class="msum-refineBtn js-refineBtn">
        <a href="javascript:;" v-on:click="handleModal">
          <span>キーワードで絞り込む</span>
        </a>
      </p>
    </div>

    <div class="remodal modalRefine" data-remodal-id="modal--refine">
      <!-- .remodal -->
      <button data-remodal-action="close" class="remodal-close"></button>
      <div class="modalRefine__header">
        <p class="modalRefine__title">キーワードで絞り込む</p>
      </div>
      <div class="modalRefine__inner">
        <div class="modalKeywordList">
          <ul class="modalKeywordList__items">
            <li class="modalKeywordList__item" v-for="item in cat_era_list" :key="item.id">
              <label>
                <input
                  type="radio"
                  v-model="cat_era"
                  v-bind:value="item.name"
                  v-on:click="handleSelectSearchTerm('era', $event)"
                />
                <span>{{ item.name }}</span>
              </label>
            </li>
          </ul>

          <ul class="modalKeywordList__items">
            <li class="modalKeywordList__item" v-for="item in cat_product_list" :key="item.id">
              <label>
                <input
                  type="radio"
                  v-model="cat_product"
                  v-bind:value="item.name"
                  v-on:click="handleSelectSearchTerm('product', $event)"
                />
                <span>{{ item.name }}</span>
              </label>
            </li>
          </ul>

          <!--
          <ul class="modalKeywordList__items">
            <li class="modalKeywordList__item" v-for="item in cat_entry_list" :key="item.id">
              <label>
                <input type="radio" v-model="cat_entry" v-bind:value="item.name" />
                <span>{{ item.name }}</span>
              </label>
            </li>
          </ul>
          -->

          <p class="modalKeywordList__filterBtn">
            <button type="button" v-on:click="handleSetSearchTerm">絞り込む</button>
          </p>
          <p class="modalKeywordList__releaseBtn">
            <button type="button" v-on:click="handleResetSearchTerm">絞り込み解除</button>
          </p>
        </div>
      </div>
      <!-- /.remodal -->
    </div>

    <div class="msum-mainConts">
      <div class="msum-mainConts__inner">
          <div v-if="entryListInitialized && storedEntryListLength < 1">
            <p class="contentsNotFound">検索結果が見つかりません。</p>
          </div>
          <div class="msum-historyWrapper" v-if="entryListInitialized && storedEntryListLength > 0">
            <section
              class="msum-historyConts"
              v-for="(target_year, index) in storedEntryList"
              :key="index"
              v-if="target_year.show_count > 0"
            >
              <div class="msum-historyConts__inner">
                <div class="msum-historyConts__year">
                  <h2 class="msum-historyConts__title">{{ target_year.west_cal }}</h2>
                  <p class="msum-historyConts__title2">{{ target_year.jp_cal }}</p>
                </div>

                <article
                  class="msum-historyArticle"
                  :class="{
                  'is-bgGry': !hasDetailLink(item.body, bodyMaxLength)
                 }"
                  v-for="item in target_year.entries"
                  :key="item.no"
                  v-if="item.flg_list_show == 1"
                >
                  <div class="msum-historyArticle__inner">
                    <h3 class="sum-historySection__title">{{ item.title }}</h3>
                    <div class="sum-historySection__img" v-if="item.img_list_path">
                      <template v-if="item.img_list_path.indexOf('youtu') !== -1">
                        <div class="msum-movBox">
                          <iframe
                            width="560"
                            height="315"
                            :src="item.img_list_path"
                            frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                          ></iframe>
                        </div>
                      </template>
                      <template v-else>
                        <img :src="base_url +'img/' + item.img_list_path" alt />
                      </template>
                    </div>
                    <div class="sum-historySection__txtBox">
                      <h4 class="sum-historySection__sTitle">{{ item.heading }}</h4>
                      <p
                        class="sum-historySection__txt"
                        v-html="$options.filters.truncate(item.body, bodyMaxLength, '...')"
                      ></p>
                    </div>
                  </div>
                  <p
                    class="msum-historyArticle__link"
                    v-if="hasDetailLink(item.body, bodyMaxLength)"
                  >
                    <router-link :to="`/product/${item.no}`">詳しく見る</router-link>
                  </p>
                  <ul class="msum-historyArticle__tag">
                    <li class="msum-historyArticle__tag__item" v-if="item.era">{{ item.era }}</li>
                    <li
                      class="msum-historyArticle__tag__item"
                      v-if="item.cat_entry"
                    >{{ item.cat_entry }}</li>
                    <li
                      class="msum-historyArticle__tag__item"
                      v-if="item.cat_product"
                    >{{ item.cat_product }}</li>
                  </ul>
                </article>
              </div>
            </section>
          </div>
      </div>
    </div>
  </main>
</template>
<style scoped>
.contentsNotFound {
  background-color: #fff;
  padding: 10% 5%;
}
.sum-historySection__txt {
  white-space: pre-wrap;
  word-wrap: break-word;
}

/* */
.historyIndex .msum-historySection__img,
.historyIndex .sum-historySection__img {
  position: relative;
  width: 43.75%;
  float: left;
  padding-top: 30%;
}

.historyIndex .msum-historySection__img img,
.historyIndex .sum-historySection__img img {
  position: absolute;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.historyIndex .msum-movBox {
  position: absolute;
  top: 0;
}
/* */

.modalKeywordList__item {
  line-height: 1.6;
}
</style>
<script>
import products from "@/api/products.js";
export default {
  data() {
    return {
      bodyMaxLength: 100,
      remodal: null,
      base_url: process.env.ASSET_BASE_PATH,

      cat_era: "",
      cat_product: "",
      cat_entry: "",
      cat_era_list: [
        { id: 1, name: "明治" },
        { id: 2, name: "大正" },
        { id: 3, name: "昭和初期" },
        { id: 4, name: "昭和中期" },
        { id: 5, name: "昭和後期" },
        { id: 6, name: "平成" }
        //        { id: 7, name: "令和" }
      ],
      cat_product_list: [
        { id: 1, name: "チョコレート" },
        { id: 2, name: "キャラメル・キャンディ" },
        { id: 3, name: "ビスケット・スナック" },
        { id: 4, name: "食品" },
        { id: 5, name: "アイス" },
        { id: 6, name: "健康" },
        { id: 7, name: "その他の商品" }
      ],
      cat_entry_list: [
        { id: 1, name: "宣伝広告" },
        { id: 2, name: "森永エピソード" }
      ]
    };
  },
  beforeDestroy: function() {
    var $window = $(window);
    $window.off("load resize scroll");
    this.remodal.destroy();
  },
  created: function() {
    // クエリーパラメータから絞り込み条件を指定
    var e = this.$route.query.e;
    var p = this.$route.query.p;
    var c = this.$route.query.c;
    var era = this.cat_era_list.find(item => {
      return item.id == e;
    });
    var product = this.cat_product_list.find(item => {
      return item.id == p;
    });
    var category = this.cat_entry_list.find(item => {
      return item.id == c;
    });

    var cat_era = era ? era.name : "";
    var cat_product = product ? product.name : "";
    var cat_entry = category ? category.name : "";

    if (era || product || category) {
      this.cat_era = cat_era;
      this.cat_product = cat_product;
      this.cat_entry = cat_entry;
    }

    this.$store.commit("searchTerm", {
      catEra: this.cat_era,
      catProduct: this.cat_product,
      catEntry: this.cat_entry
    });
  },
  mounted: function() {
    const self = this;

    this.$nextTick(() => {
      // スクロール位置の復元
      var positionY = sessionStorage.getItem("positionY");
      if (positionY !== null) {
        scrollTo(0, positionY);

        setTimeout(function() {
          scrollTo(0, positionY);
          sessionStorage.removeItem("positionY");
        }, 500);
      }
      self.handleArticleShow();
    });

    this.remodal = $("[data-remodal-id=modal--refine]").remodal();

    var $window = $(window);
    var $fixedNav = $(".js-refineBtn");
    var position = 0;
    if ($fixedNav.length) {
      var navPosition = $fixedNav.offset().top;
      $window.on("load resize", function() {
        $fixedNav.removeClass("is-fixed");
        navPosition = $fixedNav.offset().top;
        const position = $window.scrollTop();
        if (position >= navPosition) {
          $fixedNav.addClass("is-fixed");
        }
        self.handleArticleShow();
      });

      $window.scroll(function() {
        var position = $window.scrollTop();
        if (position >= navPosition) {
          $fixedNav.addClass("is-fixed");
        } else {
          $fixedNav.removeClass("is-fixed");
        }
        self.handleArticleShow();
      });
    }
  },
  computed: {
    entryListInitialized: function() {
      return this.$store.getters.initialized;
    },
    storedEntryList: function() {
      return this.$store.getters.filteredEntryList;
    },
    storedEntryListLength: function() {
      return Object.keys(this.$store.getters.filteredEntryList).length;
    },
    hasDetailLink: function() {
      return function(body, len) {
        if (body.length > len) {
          return true;
        }

        return false;
      };
    }
  },
  methods: {
    handleArticleShow: function() {
      // ファーストビューに入っている記事は初期状態で表示する
      var $window = $(window);
      $(".msum-historyArticle").each(function() {
        var t = $(this).offset().top;
        var p = t - ($window.height() / 3) * 2;

        if ($window.scrollTop() > p) {
          $(this).addClass("is-show");
        } else {
          // $(this).removeClass('is-show');
        }
      });
    },
    handleModal: function(event) {
      this.remodal.open();
    },
    handleSelectSearchTerm: function(type, event) {
      if (type == "era") {
        this.cat_product = "";
        this.cat_entry = "";
      } else if (type == "product") {
        this.cat_era = "";
        this.cat_entry = "";
      }
    },
    handleSetSearchTerm: function(event) {
      var self = this;

      var prev_cat_era = this.$store.getters.catEra;
      var prev_cat_product = this.$store.getters.catProduct;
      var prev_cat_entry = this.$store.getters.catEntry;
      if (
        prev_cat_era == this.cat_era &&
        prev_cat_product == this.cat_product &&
        prev_cat_entry == this.cat_entry
      ) {
        this.remodal.close();
        return;
      }

      var era = this.cat_era_list.find(item => {
        return item.name == this.cat_era;
      });
      var product = this.cat_product_list.find(item => {
        return item.name == this.cat_product;
      });
      var category = this.cat_entry_list.find(item => {
        return item.name == this.cat_entry;
      });

      var era_id = era ? era.id : "";
      var product_id = product ? product.id : "";
      var entry_id = category ? category.id : "";
      var query_obj = {};
      if (era_id) {
        query_obj.e = era_id;
      }
      if (product_id) {
        query_obj.p = product_id;
      }
      if (entry_id) {
        query_obj.c = entry_id;
      }

      this.$router.push({
        path: "/",
        query: query_obj
      });

      // 検索条件を変更した際の処理
      this.$store.commit("searchTerm", {
        catEra: this.cat_era,
        catProduct: this.cat_product,
        catEntry: this.cat_entry
      });

      this.$nextTick(() => {
        self.handleArticleShow();
      });

      this.remodal.close();
    },
    handleResetSearchTerm: function(event) {
      var self = this;

      if (
        this.cat_era == "" &&
        this.cat_product == "" &&
        this.cat_entry == ""
      ) {
        this.remodal.close();
        return;
      }

      this.cat_era = "";
      this.cat_product = "";
      this.cat_entry = "";

      // 検索条件をリセットした際の処理
      this.$router.push({ path: "/", query: {} });

      this.$store.commit("searchTerm", {
        catEra: "",
        catProduct: "",
        catEntry: ""
      });

      this.$nextTick(() => {
        self.handleArticleShow();
      });

      //this.remodal.close();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Home.vue